import {
  TableCell,
  tableCellClasses,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/system";

export const StyledTableCell = styled(TableCell)(({ wide }) => {
  const mobile = useMediaQuery("(max-width:720px)");
  return {
    [`&.${tableCellClasses.head}`]: {
      color: "#9E9E9E",
      marginRight: mobile ? "4px !important" : "10px !important",
      border: "none",
      whiteSpace: "nowrap",
      fontSize: mobile ? 14 : 16,
      padding: wide ? "0 50px !important" : "",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: mobile ? 13 : 15,
      border: "none",
      borderTop: "0.8px solid #e6e6e6",
    },
  };
});

export const RowTableCell = styled(TableCell)(({ font }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor:
      "linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1",
    // opacity: 0.4,
    color: "#9E9E9E",
    marginRight: "10px !important",
    //   border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: font ? font : 18,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));
